import * as React from 'react';
import { Link } from 'react-router-dom';

import { formatViews } from '../../../app/helpers/format_helper';
import { ISelectedPost } from '../../types/selected_posts';
import { getLinkForCard } from '../../../app/helpers/link_card_helper';
import { cropText } from '../../../app/helpers/format_helper';
import { IRubricsLink } from '../../types/list_item_props';
import { IRubric } from '../../reducers/modules/rubrics_menu/rubrics_menu';
import { getCategory } from '../../../app/helpers/category_helper';

import s from './selected_posts.css';

interface IProps {
  items: ISelectedPost[];
  menuItems: IRubric[];
}

export const SelectedPosts: React.FC<IProps> = props => {
  const getPostLink = (rubricInfo: IRubricsLink | IRubric, index: number) => {
    return (
      <Link
        key={`${index}_${rubricInfo.id}`}
        to={{ pathname: 'link' in rubricInfo ? (rubricInfo as IRubricsLink).link : (rubricInfo as IRubric).pathname }}
        className={s['selected-posts__content_category']}
      >
        {rubricInfo.name}
      </Link>
    );
  }

  const getRubricsPost = (post: ISelectedPost) => {
    const { menuItems } = props;
    const { attributes } = post;

    if (attributes) {
      if (attributes.rubrics && attributes.rubrics.length > 0) {
        const links = attributes.rubrics.map((rubric, index) => {
          const rubricInfo = typeof rubric === 'number'
            ? menuItems.find(menuItem => menuItem.id === rubric)
            : rubric;

          if (rubricInfo) {
            return getPostLink(rubricInfo, index);
          }

          return null;
        });

        return <span className={s['selected-posts__content_category-wrapper']}>{links}</span>;
      }

      if (attributes.type !== 'articles') {
        const category = getCategory(attributes.type);

        return (
          <span className={s['selected-posts__content_category-wrapper']}>
            <Link
              to={{pathname: `/${category.linkType}/`}}
              className={s['selected-posts__content_category']}
            >
              {category.category}
            </Link>
          </span>
        );
      }
    }

    return null;
  }

  const descendingSorting = (posts: ISelectedPost[]) => {
    return posts.sort((prev, next) =>
      Date.parse(next.attributes.datePublish) - Date.parse(prev.attributes.datePublish),
    );
  }

  const filterPosts = (posts: ISelectedPost[]) => {
    const MAX_SELECTED_POSTS = 5;
    const MAX_TITLE_LENGTH = 72;
    const descendingPosts = descendingSorting(posts);
    const postsLength = descendingPosts.length;
    const filteredPosts = [];
    let remainingSelectedNum;

    for (let i = 0; i < postsLength; i++) {
      if (filteredPosts.length >= MAX_SELECTED_POSTS) {
        return filteredPosts;
      }

      descendingPosts[i].attributes.title = cropText(descendingPosts[i].attributes.title, MAX_TITLE_LENGTH);

      if (descendingPosts[i].attributes.featured) {
        filteredPosts.push(descendingPosts[i]);
      }
    }

    remainingSelectedNum = MAX_SELECTED_POSTS - filteredPosts.length;

    if (remainingSelectedNum > 0) {
      for (let i = 0; i < postsLength; i++) {
        if (remainingSelectedNum === 0) {
          break;
        }

        if (!descendingPosts[i].attributes.featured) {
          filteredPosts.push(descendingPosts[i]);
          remainingSelectedNum--;
        }
      }
    }

    return filteredPosts;
  }

  const filteredPosts = filterPosts(props.items)

  return (
    <div className={s['selected-posts']}>
      <div className={s['selected-posts__left']}>
        <Link
            to={getLinkForCard(filteredPosts[0].id, filteredPosts[0].attributes.type, filteredPosts[0].attributes.slug)}
            className={s['selected-posts__left_item']}>
          { filteredPosts[0].attributes.image ?
            <div
              className={s['selected-posts__item_img']}
              style={{ backgroundImage: `url(${filteredPosts[0].attributes.image})`}}
            /> : <div className={s['selected-posts__item_empty-img']} />
          }
          <div className={s['selected-posts__item_content']}>
            <span className={s['selected-posts__content_title']}>
              {filteredPosts[0].attributes.title}
            </span>
            <div className={s['selected-posts__item_info']}>
              <span className={s['selected-posts__item_views']}>
                <span className={s['views-icon']} />
                <span>{formatViews(filteredPosts[0].attributes.numViews, 3)}</span>
              </span>
              { filteredPosts[0].attributes.commentsCount > 0 &&
                <span className={s['selected-posts__item_comments']}>
                  <span className={s['comments-icon']} />
                  <span>{formatViews(filteredPosts[0].attributes.commentsCount, 3)}</span>
                </span>
              }
            </div>
          </div>
        </Link>
        {getRubricsPost(filteredPosts[0])}
      </div>
      <div className={s['selected-posts__right']}>
        { filteredPosts.map((post, i) => {
          if (i === 0) {
            return;
          }

          return (
            <div
                key={`selected-${post.id}`}
                className={s['selected-posts__right_item']}>
              <Link
                  to={getLinkForCard(post.id, post.attributes.type, post.attributes.slug)}>
                { post.attributes.image ?
                    <div
                        className={s['selected-posts__item_img']}
                        style={{ backgroundImage: `url(${post.attributes.image})`}}/> :
                    <div className={s['selected-posts__item_empty-img']} />
                }
                <div className={s['selected-posts__item_content']}>
                  <span className={s['selected-posts__right_title']}>{post.attributes.title}</span>
                  <div className={s['selected-posts__item_info']}>
                    <span className={s['selected-posts__item_views']}>
                      <span className={s['views-icon']} />
                      <span>{formatViews(post.attributes.numViews, 3)}</span>
                    </span>
                    { post.attributes.commentsCount > 0 &&
                      <span className={s['selected-posts__item_comments']}>
                        <span className={s['comments-icon']} />
                        <span>{formatViews(post.attributes.commentsCount, 3)}</span>
                      </span>
                    }
                  </div>
                </div>
              </Link>
              {getRubricsPost(post)}
            </div>
          );
        })}
      </div>
    </div>
  );
}
